import { render, staticRenderFns } from "./PayConfirm.vue?vue&type=template&id=5f3e9692&scoped=true"
import script from "./PayConfirm.vue?vue&type=script&lang=js"
export * from "./PayConfirm.vue?vue&type=script&lang=js"
import style0 from "./PayConfirm.vue?vue&type=style&index=0&id=5f3e9692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e9692",
  null
  
)

export default component.exports